// extracted by mini-css-extract-plugin
export default {"root":"styles_root__c+Gn5","bg":"styles_bg__3BRl+","container":"styles_container__eApwB"};